export const CREATE_REQUEST = 'requestAcceptTerms'